import './capabilities';
import './links';
import { ResponsiveTableScroll } from './tables';

import './breakpoints-sizes.css';
import './colors.css';
import './forms.css';
import './images.css';
import './layout.css';
import './links.css';
import './lists.css';
import './tables.css';
import './typography.css';
import './utilities.css';

document.querySelectorAll('table').forEach(ResponsiveTableScroll);
